<div class="d-flex align-items-center gap-1  p-2">
  @if (breadcrumbs?.length) {
    <button
      mat-button
      routerLink="home">
      Home
    </button>
  }

  @for (breadcrumb of breadcrumbs; track breadcrumb; let first = $first) {
    <span>/</span>
    <button mat-button
      [disabled]="!breadcrumb.url"
      [routerLink]="breadcrumb.url">
      {{breadcrumb.label}}
    </button>
  }
</div>